// extracted by mini-css-extract-plugin
module.exports = {"quantitySelect":"_fbeb2149"};